import { Component, OnInit } from '@angular/core';
import { Sr } from '../interfaces/sr';
import {SrService} from '../service/sr.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../CookieAuth/auth.service';
import { promise } from 'selenium-webdriver';
import { MatDialog } from '@angular/material/dialog';
import { SrFormComponent } from '../components/sr-form/sr-form.component';
import { EtFormComponent } from '../components/et-form/et-form.component';
import { EtEnvioFormComponent } from '../components/et-envio-form/et-envio-form.component';

@Component({
  selector: 'app-sr-pendientes',
  templateUrl: './sr-pendientes.component.html',
  styleUrls: ['./sr-pendientes.component.css']
})
export class SrPendientesComponent implements OnInit {
  name:string="Mariano test";

  public sr?: any[];
  constructor(private srService:SrService, private cookie: AuthService, private dialog: MatDialog) { }

  ngOnInit(){
    this.cookie.checkExistCookie().then((data:boolean) => {
      if (data) {
        this.srService.getPendientes().subscribe(async (data:any[]) =>{
          // return data;
          this.sr=data;
          this.sr.forEach(element => {
            switch(element.etEstado){
              case 5:
                element.estilo='table-success';
              break;
              case 6:
                element.estilo='table-warning';
              break;
              case 4:
                element.estilo='table-danger';
              break;

              default:
                element.estilo='table-light';
              break;
            }
          });
          // console.log(this.sr);
        });
      } else {
        //Hacer el maldito redirect....
        // console.log("home devuelve")
        window.location.href = "/";
      }
    });


  }

  modificar(id:number){

  }
  cambiarEstado(id:number, idEstado:number):Promise<boolean>{

    return this.srService.postNewEstado(id,idEstado).then(data =>{

      if(data='ok'){
        this.srService.getPendientes().subscribe((data:any[]) =>{
          // return data;
          this.sr=data;
          this.sr.forEach(element => {
            switch(element.etEstado){
              case 5:
                element.estilo='table-success';
              break;
              case 6:
                element.estilo='table-warning';
              break;
              case 4:
                element.estilo='table-danger';
              break;

              default:
                element.estilo='table-light';
              break;
            }
          });
        });
        return true;
      }else
      {
        return false;
      }
    });

  }
abrirEt(id_sr:number){
  let dialogRef = this.dialog.open(EtFormComponent, {
    data: {id_sr: id_sr},
    maxHeight: '90vh'
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog was closed', result);
    this.srService.getPendientes().subscribe((data:any[]) =>{
      // return data;
      this.sr=data;
      this.sr.forEach(element => {
        switch(element.etEstado){
          case 5:
            element.estilo='table-success';
          break;
          case 6:
            element.estilo='table-warning';
          break;
          case 4:
            element.estilo='table-danger';
          break;

          default:
            element.estilo='table-light';
          break;
        }
      });
    });
  });
}
abrirEtM(id_et:number, id: number){
  let dialogRef = this.dialog.open(EtEnvioFormComponent, {
    data: {id_et: id_et , id: id},
    maxHeight: '90vh'
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog was closed', result);
    this.srService.getPendientes().subscribe((data:any[]) =>{
      // return data;
      this.sr=data;
      this.sr.forEach(element => {
        switch(element.etEstado){
          case 5:
            element.estilo='table-success';
          break;
          case 6:
            element.estilo='table-warning';
          break;
          case 4:
            element.estilo='table-danger';
          break;

          default:
            element.estilo='table-light';
          break;
        }
      });
    });
  });
}
  open(id:number){
    // const scrollStrategy = this.overlay.scrollStrategies.reposition();
    let dialogRef = this.dialog.open(SrFormComponent, {
      data: {id: id},
      maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      this.srService.getPendientes().subscribe((data:any[]) =>{
        // return data;
        this.sr=data;
        this.sr.forEach(element => {
          switch(element.etEstado){
            case 5:
              element.estilo='table-success';
            break;
            case 6:
              element.estilo='table-warning';
            break;
            case 4:
              element.estilo='table-danger';
            break;

            default:
              element.estilo='table-light';
            break;
          }
        });
      });

    });

  }

}
